import './index.scss';

/**
 * Vertical position in the viewport where the CE top triggers the swap.
 * 0 = top of viewport, 0.5 = vertical center, 1 = bottom.
 * Tune this (and/or SCROLL_SWITCH_OFFSET_PX) for follow-up experiments.
 */
const SCROLL_SWITCH_VIEWPORT_RATIO = 0.5;

/**
 * Extra offset (px) added to the ratio-based threshold.
 * Positive = later (lower on screen); negative = earlier.
 */
const SCROLL_SWITCH_OFFSET_PX = 0;

class ImageFullWidthScrollSwitch {
    constructor(root) {
        this.root = root;
        this.frame = root.closest('.frame-type-westfleisch_imagefullwidth') || root;
        this.altImg = root.querySelector('.image-scroll-switch__alt img');
        this.switched = false;
        this.ready = false;

        if (!this.altImg) {
            return;
        }

        this.onScroll = this.onScroll.bind(this);

        this.whenAltReady().then(() => {
            this.ready = true;
            this.onScroll();
        });

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
    }

    /**
     * Alternate <picture> is in the DOM (opacity 0), so the browser starts loading it
     * with the main image. Wait until that decode finishes before allowing the swap.
     */
    whenAltReady() {
        if (this.altImg.complete && this.altImg.naturalWidth > 0) {
            return Promise.resolve();
        }

        return new Promise((resolve) => {
            const done = () => resolve();
            this.altImg.addEventListener('load', done, { once: true });
            this.altImg.addEventListener('error', done, { once: true });
        });
    }

    getThresholdY() {
        return window.innerHeight * SCROLL_SWITCH_VIEWPORT_RATIO + SCROLL_SWITCH_OFFSET_PX;
    }

    applySwitch() {
        this.root.classList.add('is-switched');
        this.switched = true;
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
    }

    onScroll() {
        if (!this.ready || this.switched) {
            return;
        }

        if (this.frame.getBoundingClientRect().top <= this.getThresholdY()) {
            this.applySwitch();
        }
    }
}

window.app.run(() => {
    document.querySelectorAll('.frame-type-westfleisch_imagefullwidth .image-scroll-switch').forEach((node) => {
        new ImageFullWidthScrollSwitch(node);
    });
});
